import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]

import { ref, watch, computed } from 'vue'
import { getTreeNameList } from '@/utils/index'
import { useInteractionStore } from '@/stores/interaction'
import useParamCode from '@/hooks/useParamCode'
import type { ParamCodeItem } from '@/typings/common'

const __default__ = { name: 'CosCascaderText' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    appId: {},
    paramCode: {},
    options: {},
    value: {},
    desc: {}
  },
  setup(__props: any) {

const interactionStore = useInteractionStore()
const { getParamCodes } = useParamCode()

const props = __props

const langEnum = {
  'en-US': 'enName',
  'zh-CN': 'cnName'
}

const nameFormat = ref()
const language = computed(() => interactionStore.language)
const formatName = (paramCodeData: { [key: string]: ParamCodeItem[] }, key: string) => {
  const paramCodeDataObj = { ...paramCodeData }
  const config = { label: langEnum[language.value] || 'name' }
  const channelNameList = getTreeNameList(paramCodeDataObj[key], props.value, config).filter((name) => name)
  if (props.desc) channelNameList.push(props.desc)
  nameFormat.value = channelNameList.join('/')
}
const channelName = async () => {
  if (props.paramCode == null) return
  try {
    const paramCodeData = await getParamCodes(props.appId, props.paramCode)
    formatName(paramCodeData, props.paramCode)
  } catch (error) {
    console.error(error)
  }
}

watch(
  (): [number, ParamCodeItem[] | undefined] => [props.value, props.options],
  ([val, options]) => {
    if (val == null) return
    if (typeof options !== 'undefined') {
      const paramCodeData = { paramKey: options }
      formatName(paramCodeData, 'paramKey')
    } else {
      channelName()
    }
  },
  { immediate: true }
)

watch(
  () => language.value,
  () => {
    if (typeof props.options !== 'undefined') {
      const paramCodeData = { paramKey: props.options }
      formatName(paramCodeData, 'paramKey')
    } else {
      channelName()
    }
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", { title: nameFormat.value }, _toDisplayString(nameFormat.value || '--'), 9, _hoisted_1))
}
}

})